import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import React from "react";

const EditUserSkeleton = () => {
	return (
        <Grid container spacing={1.5}>
            <Grid size={12}>
				<InputRow />
			</Grid>
            <Grid size={12}>
				<InputRow />
			</Grid>
            <Grid size={12}>
				<InputRow />
			</Grid>
            <Grid size={12}>
				<InputRow />
			</Grid>
            <Grid size={12}>
				<InputRow />
			</Grid>
            <Grid size={12}>
				<InputRow />
			</Grid>
            <Grid size={12}>
				<Box sx={{ display: "flex", justifyContent: "center" }}>
					<Skeleton variant="rectangular" width={69.6} height={35.8} />
				</Box>
			</Grid>
        </Grid>
    );
};

export default EditUserSkeleton;

const InputRow = () => {
	return (
        <Grid container size={12}>
            <Grid size={5}>
				<Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
					<Skeleton width={80} height={20.5} variant="rectangular" />
				</Box>
			</Grid>
            <Grid size={7}>
				<Skeleton height={36.7} variant="rectangular" />
			</Grid>
        </Grid>
    );
};
